export default __webpack_public_path__ + "assets/icons/message_warning.c8be82ce.svg";